import React from 'react';
import SEO from '../components/SEO';

const About: React.FC = () => {
  return (
    <div className="h-full bg-gray-900 text-white flex items-center justify-center p-4">
      <SEO title="About Us | RaceLineIQ" />
      <div className="max-w-4xl mx-auto bg-gray-800 rounded-lg shadow-xl p-8 md:p-12 border border-gray-700">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-center">
          <div>
            <h1 className="text-4xl font-bold text-cyan-400 mb-4">About RaceLineIQ</h1>
            <p className="text-xl text-gray-200 mb-6">
              The first product that puts <span className="font-bold text-cyan-400">Your Performance</span> on competition day into context.
            </p>
            <p className="text-gray-300 mb-4">
              For competitive athletes, RaceLineIQ is a tactical visualization platform that crowdsources athletes data to reconstruct the race. Unlike standard fitness apps that show only personal metrics, we create a digital twin of the event, showing you exactly where you won or lost the race relative to your competition.
            </p>
            <p className="text-gray-300">
              Our mission is to enable competitive athletes to reach their highest potential.
            </p>
          </div>
          <div className="w-full h-64 bg-gray-700 rounded-lg flex items-center justify-center">
             <p className="text-gray-500">Prominent Image Placeholder</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;